/**
 * These are all actions that need to be moved to their proper location.
 * In the meantime, they were all moved here to avoid circular dependency issues.
 */

import { OrderedSet } from 'immutable';
import { ChartTypes, ReportTypes, UserResourceTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';
import { SwitchViewDomain } from '@mode/shared/contract-common';

export const enum Type {
  DestroyQuerySuccess = 'DestroyQuerySuccess',

  ClearExplorationResource = '[Exploration] ClearExplorationResource',

  ExploreChartWithData = '[Explorer] ExploreChartWithData',
  ExploreChartMark = '[Explorer] ExploreChartMark',
}

export interface DestroyQuerySuccessAction {
  type: Type.DestroyQuerySuccess;
  token: string;
  chartTokens: OrderedSet<string>;
  tableTokens: OrderedSet<string>;
}

// @TODO: (@anthonysimone) [GF] There's a lot being added/remove in this action, clean up in whatever feels more explicit
// once things have settled here
export const loadExploration = createAction(
  '[Exploration] LoadExploration', // Temporarily also in Type enum above for external reference
  props<{
    explorationToken: string;
    explorationUpdatedAt: string;
    explorationName: string;
    sourceReportName: string;
    creator: UserResourceTypes.UserResource;
    switchViewToken: string;
    dataView: SwitchViewDomain.DataView;
    explorationViz: ChartTypes.EncodedChart;
    withPersistence: boolean;
    drilldownEnabled: boolean;
    isLatestReportRun: boolean;
    isLatestSuccessfulReportRun: boolean;
    reportHasFailuresSinceLastSuccess: boolean;
    reportRunFormFields: ReportTypes.ReportRunFormField[];
    spaceName: string;
    spaceUrl: string;
    isSpaceViewable: boolean;
    defaultAccess: string;
    isCollectionCommunity: boolean;
    isCollectionPersonal: boolean;
  }>()
);

export interface ClearExplorationResource {
  type: Type.ClearExplorationResource;
}

export interface ExploreChartMark {
  type: Type.ExploreChartMark;
  target: ChartTypes.MarkTarget;
  filters: ChartTypes.Filter[];
  chartToken: string;
}

export interface ExploreChartWithData {
  type: Type.ExploreChartWithData;
  target: ChartTypes.MarkTarget;
  chartToken: string;
}

export type Union =
  | ReturnType<typeof loadExploration>
  | DestroyQuerySuccessAction
  | ClearExplorationResource
  | ExploreChartMark
  | ExploreChartWithData;
